import React from 'react'
import { Redirect } from 'react-router'
import { Row, Col } from 'react-flexbox-grid'
import styled from 'styled-components'

import NavBar from 'components/NavBar'
// import { useLazyQuery } from 'components/graphql'
import './statistics.scss'

const StyledRow = styled(Row)`
	flex-grow: 1;
`

/*const Wrapper = ({ child: SubsectionComponent, query }) => {
	const [queryStatistic, { data, queryField, loading, called }] = useLazyQuery(query)
	const isActualLoading = !data?.[queryField] && loading

	return (
		<SubsectionComponent
			getStatistic={queryStatistic}
			data={data?.[queryField]}
			showData={called}
			loading={isActualLoading}
		/>
	)
}*/

const StatisticsSection = props => {
	const { section, sectionData, subsection, subsectionData, baseUrl } = props
	const { component: SubsectionComponent, statisticQuery } = subsectionData

	if(!subsection) {
		const subsectionRedirect = sectionData?.subsections[0]?.link ?? ''
		return <Redirect to={`${baseUrl ? '/' + baseUrl : ''}${section}/${subsectionRedirect}`} />
	}

	return(
		<StyledRow>
			<Col xs={12}>
				<NavBar
					className='section'
					label={'Statistik'}
					navContent={sectionData.subsections}
					getLink={l => `${baseUrl ? '/' + baseUrl : ''}/${section}${l ? '/' + l : ''}`}
					subNav={true}
				>
					<SubsectionComponent
						key={subsection}
						query={statisticQuery}
					/>
				</NavBar>
			</Col>
		</StyledRow>
	)
}

export default StatisticsSection
